module.exports = __webpack_public_path__ + "img/imgs5.c6c63c4d.png";